/**
 * HE.Clipboard
 */

(function Clipboard($, HE)
{
	"use strict";

	var clipboard = function copyTextToClipboard(data) {
		if (navigator.clipboard) {
			modernCopy(data);
		}
		else {
			oldCopy(data);
		}
	};

	// new hotness; https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
	function modernCopy(data)
	{
		navigator.clipboard.writeText(data.text)
		.then(function copied() {
			if (data.success) {
				HE.StatusMessage('success', data.success);
			}
		}, function error(err) {
			HE.StatusMessage('error', 'Error copying to clipboard - ' + err);
		});
	}

	// deprecated
	function oldCopy(data)
	{
		var textarea = document.createElement('textarea');
		textarea.value          = data.text;
		textarea.style.top      = 0;
		textarea.style.left     = 0;
		textarea.style.opacity  = 0;
		textarea.style.position = 'fixed';
		document.body.appendChild(textarea);

		textarea.focus();
		textarea.select();

		try {
			document.execCommand('copy');

			if (data.success) {
				HE.StatusMessage('success', data.success);
			}
		} catch (err) {
			HE.StatusMessage('error', 'Error copying to clipboard - ' + err);
		}

		document.body.removeChild(textarea);
	}

	$(document).on('click', '.copy-to-clipboard', function startClipboardCopy(e) {
		var data = $(this).data();
		e.preventDefault();

		if (data.secretText) {
			data.text = atob(data.secretText);
		}

		if (!data.text) {
			throw new Error('missing text to copy');
		}

		clipboard({
			text   : data.text,
			success: data.success || null,
		});
	});

	HE.Clipboard = clipboard;
}(jQuery, window.HE || {}));
